/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Updates_UntilInputs */



/**
* | output |
* | --- |
* | "Updates included until" |
*
* @param {License_Updates_UntilInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_updates_until = /** @type {((inputs?: License_Updates_UntilInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Updates_UntilInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mises à jour incluses jusqu'au")
	if (locale === "de") return /** @type {LocalizedString} */ ("Updates enthalten bis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamenti inclusi fino al")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновления включены до")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizaciones incluidas hasta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新包含至")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップデート対象期限")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट शामिल हैं तक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizações incluídas até")
	return /** @type {LocalizedString} */ ("Updates included until")
});